<template>
  <div class="pa-4">
    <div class="d-flex align-center mb-4">
      <h2 class="text-h5 font-weight-bold">Planificare Anuală Concedii</h2>
      <v-spacer />
      <v-select v-model="an" :items="ani" label="An" variant="outlined" density="compact" style="max-width:100px" class="mr-3" @update:model-value="incarca" />
      <v-btn color="red-darken-1" prepend-icon="mdi-plus" @click="dialogLinie = true">Adaugă perioadă</v-btn>
    </div>

    <v-progress-linear v-if="loading" indeterminate color="red-darken-1" class="mb-2" />

    <DxDataGrid
      :data-source="linii"
      :show-borders="true"
      :row-alternation-enabled="true"
    >
      <DxColumn data-field="Luna" caption="Luna" :width="80" />
      <DxColumn data-field="DataInceput" caption="Data start" data-type="date" format="dd.MM.yyyy" :width="130" />
      <DxColumn data-field="DataSfarsit" caption="Data sfârșit" data-type="date" format="dd.MM.yyyy" :width="130" />
      <DxColumn data-field="NumarZile" caption="Zile" :width="70" />
      <DxColumn data-field="TipConcediu" caption="Tip" :width="120" />
      <DxColumn data-field="Observatie" caption="Observații" />
      <DxPaging :enabled="false" />
    </DxDataGrid>

    <!-- Dialog perioadă nouă -->
    <v-dialog v-model="dialogLinie" max-width="480" persistent>
      <v-card rounded="xl">
        <v-card-title class="pa-4">
          <v-icon class="mr-2" color="red-darken-1">mdi-calendar-plus</v-icon>
          Perioadă planificare
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-4">
          <v-form v-model="linieValid" ref="linieForm">
            <v-row>
              <v-col cols="6">
                <v-text-field v-model="linieForm.DataInceput" label="Data start" type="date" variant="outlined" density="compact" :rules="[required]" />
              </v-col>
              <v-col cols="6">
                <v-text-field v-model="linieForm.DataSfarsit" label="Data sfârșit" type="date" variant="outlined" density="compact" :rules="[required]" />
              </v-col>
            </v-row>
            <v-text-field v-model="linieForm.TipConcediu" label="Tip concediu" variant="outlined" density="compact" class="mt-2" />
            <v-textarea v-model="linieForm.Observatie" label="Observații" variant="outlined" density="compact" rows="2" class="mt-2" />
          </v-form>
          <v-alert v-if="saveError" type="error" variant="tonal" class="mt-2">{{ saveError }}</v-alert>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-btn variant="text" @click="dialogLinie = false">Anulează</v-btn>
          <v-spacer />
          <v-btn color="red-darken-1" :loading="saveLoading" :disabled="!linieValid" @click="salveaza">Salvează</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { DxDataGrid, DxColumn, DxPaging } from 'devextreme-vue/data-grid'
import PORTAL_PlanificareAnuala from '@/services/Portal/PORTAL_PlanificareAnuala'

export default defineComponent({
  name: 'PlanificareAnuala',
  components: { DxDataGrid, DxColumn, DxPaging },
  data() {
    const now = new Date();
    return {
      loading: false, saveLoading: false,
      an: now.getFullYear(),
      ani: [now.getFullYear(), now.getFullYear() + 1],
      linii: [] as any[],
      dialogLinie: false,
      linieValid: false,
      saveError: '',
      linieForm: { DataInceput: '', DataSfarsit: '', TipConcediu: '', Observatie: '' }
    }
  },
  mounted() { this.incarca(); },
  methods: {
    required(v: any) { return !!v || 'Câmp obligatoriu' },
    async incarca() {
      this.loading = true;
      try {
        const resp = await PORTAL_PlanificareAnuala.save({ An: this.an, Linii: [] });
        this.linii = resp.data?.Linii ?? [];
      } catch {
        // planificare goală
      } finally {
        this.loading = false;
      }
    },
    async salveaza() {
      this.saveLoading = true; this.saveError = '';
      try {
        await PORTAL_PlanificareAnuala.save({ An: this.an, Linii: [this.linieForm] });
        this.dialogLinie = false;
        await this.incarca();
      } catch (e: any) {
        this.saveError = e?.response?.data?.message ?? 'Eroare la salvare.';
      } finally {
        this.saveLoading = false;
      }
    }
  }
})
</script>
